import { render, staticRenderFns } from "./CompanyModal.vue?vue&type=template&id=5c33e945&scoped=true"
import script from "./CompanyModal.vue?vue&type=script&lang=js"
export * from "./CompanyModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c33e945",
  null
  
)

export default component.exports